import styled from 'styled-components';

export const Content = styled.div`
	height: 100%;
	max-height: 100%;
	max-width: 100%;
	overflow-y: auto;
	overflow-x: hidden;
`;

export const MainLayout = styled.div`
	display: grid;
	grid-template-columns: 15rem 1fr;
	grid-gap: 5rem;
	flex-grow: 1;
	overflow: hidden;
`;

export const InvestmentHeader = styled.div`
	display: flex;
	justify-content: space-between;
	padding-right: 0.5rem;
	padding-bottom: 1rem;
	margin-bottom: 2rem;
	border-bottom: 1px solid ${({ theme }) => theme.v3.colors.gray[2]};
`;

export const InvestmentContentWrapper = styled.div`
	margin-bottom: 3em;
`;

export const Layout = styled.div`
	display: flex;
	padding: 1rem 2rem 2rem 2rem;
	flex-direction: column;
	height: 100%;
	box-sizing: border-box;
	gap: 2rem;
`;
